import { render, staticRenderFns } from "./SendMessageOtherUserGroupReadMembersModal.vue?vue&type=template&id=41487ae6&lang=pug"
import script from "./SendMessageOtherUserGroupReadMembersModal.vue?vue&type=script&lang=ts"
export * from "./SendMessageOtherUserGroupReadMembersModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports